import { NVButton } from '@nv/basic-components'
import { useAdminUserContext } from '@nv/contexts'
import CalendarIcon from '@nv/images/design/calendar-icon'
import { GearIcon } from '@nv/images/design/gear-icon'
import { ListIcon } from '@nv/images/design/list-icon'
import { beforeUnload } from '@nv/utils'
import { useTranslation } from 'react-i18next'
import styles from './EventHeader.module.scss'

export const EventHeader = ({ setCurrentView, currentView, hasCreateEventBtn }: any) => {
  const { t, i18n } = useTranslation()
  const currentLanguage = i18n.language
  const { tiviLink } = useAdminUserContext()

  return (
    <div className={styles['container']}>
      <div className={styles['content']}>
        <span className={styles['content__title']}>{t('pages.events')}</span>

        <div className={styles['icons']}>
          <NVButton
            variant='iconOnly'
            onClick={() => setCurrentView('EventsCalendar')}
            icon={<CalendarIcon inactive={currentView === 'EventsCalendar'} />}
            style={{ container: { marginRight: '1rem' } }}
            ariaLabel={t('events.calendar')}
          />
          <NVButton
            variant='iconOnly'
            onClick={() => setCurrentView('EventsList')}
            icon={<ListIcon inactive={currentView === 'EventsList'} />}
            ariaLabel={t('events.events')}
          />
        </div>

        {hasCreateEventBtn && (
          <NVButton
            variant='primaryGrey'
            text={t('admin.emsLink')}
            height={40}
            onClick={() => {
              window.removeEventListener('beforeunload', beforeUnload)
              window.location.href = `${tiviLink}?locale=${currentLanguage || 'en'}`
            }}
            icon={<GearIcon />}
          />
        )}
      </div>
    </div>
  )
}
